"use client"

import React, { FC, useState } from "react"
import { ControlledModal, toast } from "@/components"
import { graphql } from "@/gql"
import { useMutation } from "@apollo/client"
import { ClientPortfolioDocument, DeleteCreativeWorkPortfolioProjectDocument } from "@/gql/graphql"
import { revalidateTagsHelper } from "@/utils/revalidateTagHelper"
import { useEditPortfolio } from "./useEditPortfolio"

interface Props {
  isOpen: boolean
  onOpenChange: (isOpen: boolean) => void
  editProfileMethods?: ReturnType<typeof useEditPortfolio>
}

graphql(`
  mutation DeleteCreativeWorkPortfolioProject($input: DeleteCreativeWorkPortfolioProjectInput!) {
    deleteCreativeWorkPortfolioProject(input: $input) {
      ok
    }
  }
`)

export const DeleteProjectModal: FC<Props> = ({ isOpen, onOpenChange, editProfileMethods }) => {
  const [deleteProject] = useMutation(DeleteCreativeWorkPortfolioProjectDocument)
  const [loading, setLoading] = useState(false)

  const onDelete = async () => {
    if (editProfileMethods?.deleteProjectId && !loading) {
      setLoading(true)
      const response = await deleteProject({
        variables: {
          input: {
            id: editProfileMethods.deleteProjectId!,
          },
        },
        refetchQueries: [ClientPortfolioDocument],
      })

      if (response?.data?.deleteCreativeWorkPortfolioProject?.ok) {
        revalidateTagsHelper(["server-portfolio-query"])
        onOpenChange(false)
      } else {
        toast.error("Error deleting project")
      }
      setLoading(false)
    }
  }

  return (
    <ControlledModal
      open={isOpen}
      onOpenChange={onOpenChange}
      header={{
        title: "Delete project",
        subtitle: "Are you sure you want to delete this project? This action can’t be undone.",
        variant: "warning",
      }}
      footer={{
        fixed: true,
        tertiaryButton: {
          children: "Close",
          onClick: () => onOpenChange(false),
        },
        primaryButton: {
          children: "Delete project",
          onClick: onDelete,
          loading: loading,
        },
      }}
    />
  )
}
